import {
  InterestRateChart,
  InterestRateLegend,
  Skeleton,
  Text,
} from '@tectonicfi/tectonic-ui-kit';
import { memo, useMemo } from 'react';

import Card from '@components/Card';
import useIsMobile from '@hooks/useIsMobile';
import { getInterestRate, InterestRate } from '@lib/math';
import { PoolType } from '@config/base';

interface InterestRateCardProps {
  mode: PoolType;
  assetSymbol: string;
  currentBorrowAPY: number | null;
  currentSupplyAPY: number | null;
  currentUtilizationRate: number | null;
}
function InterestRateCard({
  mode,
  assetSymbol,
  currentBorrowAPY,
  currentSupplyAPY,
  currentUtilizationRate,
}: InterestRateCardProps): JSX.Element {
  const isMobile = useIsMobile();
  const data: InterestRate[] | null = useMemo(() => {
    if (currentUtilizationRate === null) {
      return null;
    }

    return getInterestRate(
      mode,
      assetSymbol,
      currentBorrowAPY,
      currentSupplyAPY,
      currentUtilizationRate
    );
  }, [
    mode,
    assetSymbol,
    currentBorrowAPY,
    currentSupplyAPY,
    currentUtilizationRate,
  ]);

  return (
    <Card
      variant={isMobile ? 'no-background' : 'default'}
      border={isMobile ? false : true}
      padding={isMobile ? 'none' : 'default'}
      className="relative"
    >
      <Text variant="heading3">Interest Rate Model</Text>
      <div className="h-[557px]">
        {data ? (
          <InterestRateChart data={data} />
        ) : (
          <Skeleton className="h-full" />
        )}
      </div>
      <InterestRateLegend className="pt-2 pl-2 tablet:flex-col" />
    </Card>
  );
}

export default memo(InterestRateCard);
